<template>
    <div class="row">
      <div class="col-md-12 more-info-header">
        <ol class="carousel-indicators">
          <li data-target="#carouselExampleIndicators"  v-bind:class="{'active': currentPage('About')}"><router-link :to="{ name: 'About' }"></router-link></li>
          <li data-target="#carouselExampleIndicators" v-bind:class="{'active': currentPage('Staff')}"><router-link :to="{ name: 'Staff' }"></router-link></li>
          <li data-target="#carouselExampleIndicators" v-bind:class="{'active': currentPage('Research')}"><router-link :to="{ name: 'Research' }"></router-link></li>
          <li data-target="#carouselExampleIndicators" v-bind:class="{'active': currentPage('Donate')}"><router-link :to="{ name: 'Donate' }"></router-link></li>
        </ol>
      </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  methods:{
    currentPage: function(page){      
      if(this.$route.name == page){
        return true;
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/more_info/Header.vue